<template>
  <el-container class="layout-content">
    <!-- 头部-->
    <el-header height="80px">
        <slot name="top"></slot>
    </el-header>
    <!-- 右侧页面 -->
    <el-main>
      <!-- 页面内容 -->
      <div class="main">
        <slot name="content"></slot>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  created(){},

  mounted(){},

  methods: {}
}

</script>
<style scoped>
.main{
  width:100%;
  display: flex;
}
</style>